import { Controller } from "stimulus"
import SimpleMDE from 'simplemde'

export default class extends Controller {
  static targets = [ "field" ]

  connect() {
    this.editor = new SimpleMDE({
      element: this.fieldTarget,
      spellChecker: false
    });

    var token = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    inlineAttachment.editors.codemirror4.attach(this.editor.codemirror, {
      uploadUrl: '/admin/attachments',
      extraHeaders: { 'X-CSRF-Token': token }
    });
  }
}
